<template>
  <XemGroup />
</template>

<script>
import XemGroup from "@/components/pages/quan-tri-he-thong/group/XemGroup.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";
export default {
  name: "TrangXemGroup",
  components: {
    XemGroup
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME
      } / ${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.XEM
      }`
    );
  }
};
</script>


